import React, { useMemo } from "react";

/**
 * Ambient golden sparkles for the open-state backdrop.
 * Pure-CSS animation (no canvas) so it stays performant and accessible.
 */
export default function Sparkles({ count = 34 }) {
  const dots = useMemo(() => {
    const rand = (min, max) => Math.random() * (max - min) + min;
    return Array.from({ length: count }).map((_, i) => ({
      id: i,
      left: rand(2, 98),
      top: rand(8, 92),
      size: rand(1.6, 4.2),
      delay: rand(0, 6),
      duration: rand(3.5, 7.5),
      drift: rand(-14, 14),
      driftY: rand(-10, 10),
    }));
  }, [count]);

  return (
    <div
      className="fixed inset-0 z-[1] pointer-events-none overflow-hidden"
      aria-hidden="true"
    >
      {dots.map((d) => (
        <span
          key={d.id}
          className="sparkle-dot"
          style={{
            left: `${d.left}%`,
            top: `${d.top}%`,
            width: `${d.size}px`,
            height: `${d.size}px`,
            "--drift": `${d.drift}px`,
            "--driftY": `${d.driftY}px`,
            animationDelay: `${d.delay}s`,
            animationDuration: `${d.duration}s`,
          }}
        />
      ))}
    </div>
  );
}
